import { useEffect, useState } from "react";
import { useForm } from 'react-hook-form'

import Modal from '../Modal';
import { createTaskResource } from "../../api/tasks.api";
import { getTaskResource, updateTaskResource } from "../../api/taskResource.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import {validateUrlService} from "../../services/urlService.js";

export default function TaskResourceModal({ task, taskResourceId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[taskResource, setTaskResource] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();

    const getTaskResourceError = error => {
        setTaskResource({})
        showError(`Error al recuperar el recurso. ${error.message}`)
    }

    useEffect(() => {
        async function loadTaskResource() {
            if(taskResourceId){
                const res = await getTaskResource(taskResourceId,getTaskResourceError)
                setTaskResource(res.data)
                setValue('name', res.data.name)
                setValue('description', res.data.description)
                setValue('link', res.data.link)
            }
        }
   
        loadTaskResource()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(task){
            return(<h1 className='font-bold text-2xl'>{task.name} - Agregar recurso</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar recurso</h1>)
        }
    }
    
    
    const handleSave = handleSubmit(async data => {
        if(task && task.id){
            if(validateUrlService(data.link)){
                const payload = {
                    name: data.name,
                    description: data.description,
                    link: data.link
                }     
                await createTaskResource(task.id, payload, createTaskResourceSuccess, createTaskResourceError)
            }else{
                showError("Url link not valid. Debe comenzar con http:// o https://")
            }   
        }
    })
    const handleUpdate = handleSubmit(async data => {
        if(taskResourceId){
            if(validateUrlService(data.link)){
                const payload = {
                    name: data.name,
                    description: data.description,
                    link: data.link
                }
        
                await updateTaskResource(taskResourceId, payload, updateTaskResourceSuccess, updateTaskResourceError)
            }else{
                showError("Url link not valid. Debe comenzar con http:// o https://")
            }   
        }
    })

    const createTaskResourceSuccess = (res => {
        showSuccess('Recurso creado')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createTaskResourceError = (error => {
        showError(`Error al crear el recurso. ${error.message}. ${error.response.data}`)
    })

    const updateTaskResourceSuccess = (res => {
        showSuccess('Recurso actualizado')
        refreshProjectsCategory(category)
        handleClose()
    })

    const updateTaskResourceError = (error => {
        showError(`Error al actualizar el recurso. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        if(!taskResourceId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>

                <form action="" >
                    <div className="grid grid-cols-2 gap-2">
                        <input
                            type="text"
                            placeholder="Nombre"
                            {...register("name", { required: true })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                        />
                        {errors.name && <span>Campo requerido</span>}

                        <input
                            type="text"
                            placeholder="Link"
                            {...register("link", { required: true })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                        />
                        {errors.link && <span>Campo requerido</span>}
                        <textarea
                            rows="3"
                            placeholder="Descripción"
                            {...register("description", { required: false })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3 col-span-2'
                        />
                        {errors.description && <span>Campo requerido</span>}

                    </div>
                </form>
                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}